import { Fragment } from "react";
import { useSelector, dispatch, useDispatch } from "react-redux";
import { Toolbar, ToolbarItem, ToolbarSeparator, ToolbarSpacer, Button } from "@progress/kendo-react-buttons";
import { Form, FormElement } from "@progress/kendo-react-form";
import { WidgetFilterFormParameters } from "./widgetfilterformparameters";
import { WidgetFilterFormSearch } from "./widgetfilterformsearch";
import { addNotification } from "../../../redux/slices/notificationsslice";
import { setPageValue, showFilterFormValueKeys } from "../../../redux/slices/reportingviewpageslice";
import { isInteger, isEmptyObject, isNumeric, notificationDurationMiddle, beepFile } from "../../../lib/utils";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const WidgetFilterFormSinglePage = props => {
    const {
        pageState, formState, canManageSearchSchema,
        formValidator, onFormSave, onPrevious, onNext, onFormSearchSchemaLoad, onFormSearchSchemaSave,
        onFormValueChange, onFilterParameterChange, onSearchChange, onKeyChange,
        onClear, onClose, ...other 
    } = props;

    const currentTheme = useSelector(state => state.currentTheme);
    const dispatch = useDispatch();
    //const parameters = formState.parameters;

    const { t } =useTranslation();

    const hasParameters = formState.parameters != null && formState.parameters.length > 0;
    const hasFields = formState.whereObject && formState.whereObject.rules && formState.whereObject.rules.length > 0;

    const handleOnSearchSchemaSave = () => {
        let hasParameters = formState.parameters != null && formState.parameters.length > 0;
        let hasFields = formState.whereObject && formState.whereObject.rules && formState.whereObject.rules.length > 0;

        //make sure 1+ rule or 1+ parameter exists
        // if (!hasParameters && !hasFields)
        // {
        //     dispatch(addNotification({text: "No search criteria to save.", type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
        //     return;
        // }
        
        //build the dto - need to fill it later when i create an sp dataset
        let dateExists = false;

        //my api rules list to fill
        var rules = [];

        //existing query builder rules
        let _rules = formState.whereObject.rules;
        let fields = formState.whereFields;

         ///////////////////////
        //start with parameters, if any, as below
        ///////////////////////

        if (hasFields)
        {
            for(let r in _rules)
            {
                let rule = _rules[r];
                let fieldName = rule.field;                

                //locate in where fields
                let field = fields.find (e => e.Name == fieldName);
                if (!field)
                {
                    dispatch(addNotification({text: t("reporting.view.field8") + fieldName + t("reporting.view.field9"), type: "error", closable: true, duration:notificationDurationMiddle, position:"topRight"}));
                    return;
                }

                if (field.DataTypeId == 4 || field.DataTypeId == 5)
                    dateExists = true;

                rules.push({
                    ruleId: rule.id, operatorName: rule.operator, valueKey: "0", value: rule.value, dataTypeId: field.DataTypeId,
                    fieldId: field.Id, fieldName: fieldName, fieldTitle: field.Title, 
                    parameterId: 0, parameterTitle: "", parameterName: "",
                    componentId: fieldName + rule.id.replace("-", "").replace(".", ""), label: field.Title
                });
            }
        }

       

        //fill searchSchemaTemp
        dispatch(setPageValue({id: "searchSchemaTemp", value: {
            reportId: pageState.reportId, 
            whereObject: JSON.stringify(formState.whereObject), 
            rules: rules
        }}));

        //if date exists show the dialog of value keys
        if (dateExists)
           dispatch(showFilterFormValueKeys());
        else
            onFormSearchSchemaSave();
    };

    return (
        <Fragment>
            <div className="widget-filter-form">
                <Form    
                    validator={formValidator} 
                    key={formState.formKey}
                    initialValues={formState.formInitialValues}                
                    render={(formRenderProps) => {
                        return (
                            <FormElement horizontal={false}
                                    style={{
                                        // width: 250,
                                    }}
                            >                       
                                <div className="toolbar">
                                    <Toolbar>
                                        {/* {
                                            formState.pageIndex > 0 && hasParameters &&
                                            <Fragment>
                                                <ToolbarItem>
                                                    <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="arrow-60-left" onClick={onPrevious}>
                                                        Previous
                                                    </Button>
                                                </ToolbarItem>
                                                <ToolbarSeparator/>
                                            </Fragment>
                                        }
                                        {
                                            formState.pageIndex == 0 && hasParameters &&
                                            <Fragment>
                                                <ToolbarItem>
                                                    <Button disabled={pageState.processing } style={{color: currentTheme.primary}}   icon="arrow-60-right" onClick={onNext}>
                                                        Next
                                                    </Button>
                                                </ToolbarItem>
                                                <ToolbarSeparator/>
                                            </Fragment>
                                        }                                        */}
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="save" onClick={onFormSave}>
                                                    {t("reporting.view.apply")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>                                          
                                        {   
                                            formState.isGlobal && canManageSearchSchema && /*(hasParameters || hasFields) && */
                                            <Fragment>
                                                <ToolbarItem>
                                                    <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="filter-add-expression" onClick={handleOnSearchSchemaSave}>
                                                       {t("reporting.view.savesearch")}
                                                    </Button>
                                                </ToolbarItem>
                                                <ToolbarSeparator/>
                                            </Fragment>  
                                        }            
                                        {   
                                            formState.isGlobal && pageState.searchSchema &&
                                            <Fragment>
                                                <ToolbarItem>
                                                    <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="clip" onClick={onFormSearchSchemaLoad}>
                                                        {t("reporting.view.load")}
                                                    </Button>
                                                </ToolbarItem>
                                                <ToolbarSeparator/>
                                            </Fragment>                                        
                                        }                 
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="cancel" onClick={onClear}>
                                                    {t("reporting.view.clear")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>                       
                                        <Fragment>
                                            <ToolbarItem>
                                                <Button disabled={pageState.processing} style={{color: currentTheme.primary}}   icon="clear" onClick={onClose}>
                                                    {t("reporting.view.close")}
                                                </Button>
                                            </ToolbarItem>
                                            <ToolbarSeparator/>
                                        </Fragment>                        
                                    </Toolbar>            
                                </div>
                                <div className="form-content">
                                    {
                                        // formState.pageIndex == 0 && hasParameters &&
                                        <WidgetFilterFormParameters formRenderProps={formRenderProps} pageState={pageState} formState={formState}                                          
                                            onFormValueChange={onFormValueChange} onParameterChange={props.onFilterParameterChange} isGlobal={formState.isGlobal} 
                                            /> 
                                    }
                                    {
                                        // formState.pageIndex == 1 &&
                                        <WidgetFilterFormSearch formRenderProps={formRenderProps}  pageState={pageState} formState={formState} 
                                            onFormValueChange={onFormValueChange} onSearchChange={onSearchChange} isGlobal={formState.isGlobal} onKeyChange={onKeyChange}  
                                            /> 
                                    }
                                </div>
                            </FormElement>
                        );
                    }}
                />
            </div>        
            <style>
                {
                    `
                    .widget-filter-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        height: 100%;
                    }

                    /*form toolbar*/
                    .widget-filter-form .toolbar .k-toolbar
                    {
                      width: 100%;
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      padding: 3px 4px 2px 0px;
                      background-color: ${currentTheme.appBarBg}; /*transparent;*/
                    }

                    .widget-filter-form .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                      background-color:transparent;
                    }

                    .widget-filter-form .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor};/* ${currentTheme.primary}*/
                    }

                    .widget-filter-form .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .widget-filter-form .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .widget-filter-form .toolbar .k-toolbar .k-button:active::before, .widget-filter-form .toolbar .k-toolbar .k-button:hover::before,
                    .widget-filter-form .toolbar .k-toolbar .k-button:focus::before, .widget-filter-form .toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .widget-filter-form .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${currentTheme.componentBg} !important;*/
                        box-shadow: none !important;
                    }                       

                    .widget-filter-form .toolbar .k-toolbar .k-button .k-button-text
                    {
                        font-size: 13px;
                        font-weight: 400;
                        color: ${currentTheme.appBarLinkColor};//${currentTheme.componentText};
                    }

                    .widget-filter-form .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.appBarLinkColor};/*${currentTheme.primary};*/
                    }

                    .widget-filter-form .toolbar .k-toolbar .k-button:hover .k-button-text
                    {
                        font-weight: 700;
                        font-size: 12.2px;
                    }
                    /*form toolbar*/


                    /*form content*/
                    .widget-filter-form .form-content
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        overflow: auto;
                        padding: 8px;
                    }
                    /*form content*/


                    .widget-filter-form .k-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        overflow: hidden;
                    }

                    /*utils form classes*/
                    .widget-filter-form-group
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        margin-bottom: 16px;
                        padding: 0;
                    }

                    .widget-filter-form-group > .header
                    {
                        font-size: 14px;
                        font-weight: 700;
                        padding: 6px;
                        
                    }
                    .widget-filter-form-group > .content
                    {
                        flex:1;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        padding: 10px 6px 6px 12px;
                    }

                    .widget-filter-form-group > .content > .row
                    {
                        display: flex;
                        align-items: flex-end;
                        justify-content: space-between;
                        margin-bottom: 16px;
                    }

                    .widget-filter-form-group > .content > .row .k-form-field
                    {
                        margin-top: 0px;
                    }
                    /*utils form classes*/
                    

                    /*format input components*/
                    .widget-filter-form .k-form .k-label
                    {
                        font-size: 13px;
                        margin-bottom: 3px;
                    }

                    /*formatting inputs and drop down lists to make them thicker/thiner*/
                    .widget-filter-form .k-form .k-input, .k-form .k-dropdownlist
                    {                        
                        border-left: 3px solid ${currentTheme.primary};
                    }

                    .widget-filter-form .k-form .k-input, .k-form .k-dropdownlist .k-input-inner
                    {
                        background-color: ${currentTheme.componentBg};
                    }

                    .widget-filter-form .k-form .k-input
                    {
                    }

                    .widget-filter-form .k-dropdownlist button
                    {
                    }

                    .widget-filter-form .k-dropdownlist .k-input-inner
                    {
                    }

                    .widget-filter-form .k-form .k-input.k-invalid, .widget-filter-form .k-form .k-dropdownlist.k-invalid
                    {
                        border-top-color: ${currentTheme.componentBorderColor};
                        border-bottom-color: ${currentTheme.componentBorderColor};
                        border-right-color: ${currentTheme.componentBorderColor};
                    }

                    .widget-filter-form .k-form .k-input:focus, .widget-filter-form .k-form .k-input.k-textarea:focus, .widget-filter-form .k-form .k-input.k-textarea:active, .widget-filter-form .k-form .k-dropdownlist:focus
                    {
                        box-shadow: none !important;
                        outline: none;
                    }

                    .widget-filter-form .k-form .k-input-solid:focus-within
                    {
                        box-shadow: none;
                    }

                    @media (max-width: 600px)
                    {
                        .widget-filter-form .toolbar .k-toolbar
                        {
                            flex-wrap: wrap;
                            gap: 4px;
                            overflow: visible;
                            padding: 4px 6px;
                        }

                        .widget-filter-form .toolbar .k-separator
                        {
                            display: none;
                        }

                        .widget-filter-form .form-content
                        {
                            padding: 8px 6px;
                        }

                        .widget-filter-form-group > .content
                        {
                            padding: 10px 6px;
                        }
                    }
                    /*format input components*/
                    `
                }
            </style>
        </Fragment>
    );
}
